export default {
  formId: 'estadisticasDiarioForm',
  formField: {
    nombre_cliente: {
      name: 'nombre_cliente',
      label: 'Cliente',
      requiredErrorMsg: 'El cliente es requerido',
    },
    startDate: {
      name: 'startDate',
      label: 'Fecha Inicial',
      requiredErrorMsg: 'La fecha inicial es requerida',
    },
    endDate: {
      name: 'endDate',
      label: 'Fecha Final',
      requiredErrorMsg: 'La fecha final es requerida',
    },
  },
};
